import React from 'react';
import { Box } from 'investira.react.components';
import { ErrorBoundary } from '../../molecules';

const WarpTemplate = props => {
  return (
    <ErrorBoundary>
      <Box
        id="warp"
        sx={{
          flexGrow: 1,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'background.dark'
        }}>
        {props.children}
      </Box>
    </ErrorBoundary>
  );
};

export default WarpTemplate;
